import { AuthLevel, generateApiPath } from '@guiker/api-definition'

const paths = {
  notificationPreference: generateApiPath({ prefix: AuthLevel.JWT_AUTH, name: 'notification-preference' }),
}

export { paths }
